import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0a0a0a] text-gray-400 py-12 text-center" data-id="element-85">
      <div className="container mx-auto px-6" data-id="element-86">
        <div className="font-serif text-2xl font-bold text-white mb-4 tracking-wider" data-id="element-87">
          SCORE <span className="text-brand-gold" data-id="element-88">700</span>
        </div>
        <p className="text-sm mb-6" data-id="element-89">Sistema de Crédito en USA</p>
        <div className="flex justify-center gap-6 text-sm mb-8" data-id="element-90">
          <a href="#" className="hover:text-white transition-colors" data-id="element-91">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-92">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-93">
            Contacto
          </a>
        </div>
        <p className="text-xs text-gray-600" data-id="element-94">
          &copy; {currentYear} SCORE 700. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}